import * as Models from 'contracts/models';

export type DataItem = Models.Search.Item;

export interface FormattedDataItem {
    image: string;
    type: string;
    title: string;
    description: string;
    published: Date;
    views: number;
    exact: boolean;
    references: number | null;
    exploits: number | null;
    affectedSoftware: number | null;
    affectedPackages: number | null;
    affectedConfiguration: number | null;
    cvssScore: number | null;
    aiScore: number | null;
    epssScore: number | null;
    isWild: boolean;
    tags: string[];
    href: string;
    webApplicable?: boolean;
}

export enum View {
    LIST = 'list',
    TABLE = 'table'
}
